/* eslint-disable */
import React, { useEffect, useState } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import useFormValidator from 'useFormValidator';
import PropTypes from 'prop-types';
import * as actions from '../../actions';
import NumberFormat from 'react-number-format';

function ActivityComponent({
  formData,
  setFormData,
  itemId,
  data,
  getNecessaryFieldsList,
}) {
  const [formUpdate, setFormUpdate] = useState({
    ...data,
    amount: '',
    discount: 0,
    penalty: 0,
    total_amount: 0,
  });
  const [formDetails] = useState(data.details);

  const validateUpdateForm = useFormValidator(formUpdate, {
    amount: 'required',
    discount: 'required',
    penalty: 'required',
  });

  useEffect(() => {
    setFormData({
      ...formData,
      // activities: [formData.activities[itemId] ? formUpdate : formData.activities]
      activities: [
        ...formData.activities.map((item, index) =>
          index === itemId ? formUpdate : item
        ),
      ],
    });
  }, [_.get(formUpdate, 'total_amount')]);

  useEffect(() => {
    setFormUpdate((prevUpdate) => ({
      ...prevUpdate,
      details: formDetails,
    }));
  }, [formDetails, _.get(formUpdate, 'details')]);

  useEffect(() => {
    if (_.get(formUpdate, 'business_line_id')) {
      const args = { business_line_id: _.get(formUpdate, 'business_line_id') };
      getNecessaryFieldsList(args);
    }
  }, [_.get(formUpdate, 'business_line_id')]);

  useEffect(() => {
    validateUpdateForm.validate();
  }, [Object.values(formUpdate).join(',')]);

  return (
    <>
      {/* Business Activity Field */}
      <div className="form-input-group px-3">
        <div className="form-row">
          <label htmlFor="last_name" className="form-label mb-0">
            Amount {validateUpdateForm.renderMessage('amount')}
          </label>
        </div>
        <NumberFormat
          name="amount"
          id="amount"
          placeholder="0"
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            setFormUpdate({
              ...formUpdate,
              amount: floatValue || '',
              total_amount:
                (floatValue || 0) -
                  _.get(formUpdate, 'discount', '') +
                  _.get(formUpdate, 'penalty', '') || '',
            });
          }}
          isNumericString={true}
          thousandSeparator={true}
          allowNegative={true}
          allowLeadingZeros={true}
          displayType="input"
          prefix=""
          value={`${_.get(formUpdate, 'amount', '')}` || ''}
        />
      </div>
      <div className="form-input-group px-3">
        <div className="form-row">
          <label htmlFor="last_name" className="form-label mb-0">
            Discount {validateUpdateForm.renderMessage('discount')}
          </label>
        </div>
        <NumberFormat
          name="discount"
          id="discount"
          placeholder="0"
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            setFormUpdate({
              ...formUpdate,
              discount: floatValue || 0,
              total_amount:
                _.get(formUpdate, 'amount', '') -
                  floatValue +
                  _.get(formUpdate, 'penalty', '') || '',
            });
          }}
          isNumericString={true}
          thousandSeparator={true}
          allowNegative={true}
          allowLeadingZeros={true}
          displayType="input"
          prefix=""
          value={`${_.get(formUpdate, 'discount', '')}` || ''}
        />
      </div>
      <div className="form-input-group px-3">
        <div className="form-row">
          <label htmlFor="last_name" className="form-label mb-0">
            Penalty {validateUpdateForm.renderMessage('penalty')}
          </label>
        </div>
        <NumberFormat
          name="penalty"
          id="penalty"
          placeholder="0"
          className="form-control"
          onValueChange={(values) => {
            const { floatValue } = values;
            setFormUpdate({
              ...formUpdate,
              penalty: floatValue || 0,
              total_amount:
                _.get(formUpdate, 'amount', '') -
                  _.get(formUpdate, 'discount', '') +
                  floatValue || '',
            });
          }}
          isNumericString={true}
          thousandSeparator={true}
          allowNegative={true}
          allowLeadingZeros={true}
          displayType="input"
          prefix=""
          value={`${_.get(formUpdate, 'penalty', '')}` || ''}
        />
      </div>
      <div className="form-input-group px-3">
        <div className="form-row">
          <label htmlFor="last_name" className="form-label mb-0">
            Total Amount
          </label>
        </div>
        <NumberFormat
          name="total_amount"
          id="total_amount"
          placeholder="0"
          className="form-control"
          isNumericString={true}
          thousandSeparator={true}
          allowNegative={true}
          allowLeadingZeros={true}
          displayType="input"
          prefix=""
          value={`${_.get(formUpdate, 'total_amount', '')}` || 0}
          disabled
        />
      </div>
    </>
  );
}

ActivityComponent.propTypes = {
  itemId: PropTypes.number.isRequired,
  data: PropTypes.instanceOf(Object).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = ({}) => ({});

const enhance = _.flowRight([
  withRouter,
  connect(mapStateToProps, { ...actions }),
]);

export default enhance(ActivityComponent);

// export default ActivityComponent;
